module.exports = __webpack_public_path__ + "img/25_15.e5d96517.png";